<template>
  <div>
    <div class="yahome-footer" style="cursor: default">
      <a href="https://www.asecl.com.tw/" target="_blank">ASECL-Recruit</a>

      &copy; {{ new Date().getFullYear() }}
      <a :href="`${url}/#/privacy_policy`" target="_blank">Privacy Policy</a>
      <template v-if="page === 'HomePage'">
        <div style="position: absolute; right: 10px; top: 0.2px" v-show="false">
          <span style="margin-right: 5px; vertical-align: middle">v1.010</span>
          <eva-icon 
            name="bell-outline"
            fill="#FFF"
            width="18px"
            height="18px"
            style="cursor: pointer"
            data-toggle="modal"
            data-target="#delModal"
          />
        </div>
      </template>
    </div>
    <div id="delModal" class="modal fade" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">版更紀錄</div>
          <div class="modal-body">
            <strong> v1.010</strong>
            <h5><span class="badge badge-success">新增功能</span></h5>
            <p>
              人才庫 | 新增檢視履歷按鈕，使用者除了觀看歷程外也可直接觀看履歷。<br />
              填寫履歷 |
              學校、科系、語言增加其他選項，供使用者輸入。<br />
            </p>
            <h5><span class="badge badge-primary">優化項目</span></h5>
            <p>
              登入權限 | 修改權限簽章資訊。<br />
              需求單 | 已結案需求單移除招募期限的日期卡控。<br />
              組織管理 | 人員查詢增加 EMAIL 搜尋條件。<br />
              報到通知範本 | 新增時間參數，供發送信件時參數使用。<br />
              報到查詢 | 新增報到時間搜尋條件。<br />
              招聘進度 | 邀約面談，增加招募期限查詢條件。<br />
            </p>
            <h5><span class="badge badge-warning">修正程式</span></h5>
            <p>
              人才庫 | 修正查詢結果，分頁異常問題。<br />
              系統選單 | 修改自動收合功能，改為單獨展開及收合。<br />
              組織管理 | 修正部門裡有人員卻可以刪除部門之問題。<br />
              組織管理 | 修正人員匯入，是否為部門主管無法正常顯示之問題。<br />
              面談邀約 | 修正面談地點輸入過多文字無法送出之問題。<br />
              首頁 | 修正職缺列表切換分頁功能。<br />
              履歷填寫 | 修正大頭照無緩存之問題。<br />
              人事資料表 | 修正畫面無法滾動之問題。<br />
              需求單查詢 | 修正搜尋結果與搜尋筆數異常之問題。<br />
            </p>
            <hr class="mt-4" style="border-top: 1px dashed #808080" />
            <strong> v1.009</strong>
            <h5><span class="badge badge-success">新增功能</span></h5>
            <p>
              語系維護 | 新增維護頁面。<br />
              選單多國 | 新增選單多國語系、供使用者自定義對應顯示文字。<br />
              RPA模組 | 新增同步履歷設定功能(排程、信件參數)、同步紀錄。<br />
              飛騰串接模組 | 面談結果串接至飛騰系統進行簽核。<br />
            </p>
            <h5><span class="badge badge-primary">優化項目</span></h5>
            <p>需求申請 | 科系選擇增加搜尋功能。</p>
            <h5><span class="badge badge-warning">修正程式</span></h5>
            <p>飛騰串接模組 | 修正任用單送出至飛騰的表單名稱。</p>
            <hr class="mt-4" style="border-top: 1px dashed #808080" />
            <strong> v1.008</strong>
            <h5><span class="badge badge-success">新增功能</span></h5>
            <p>填寫履歷 | 同步104履歷功能(登入104帳號自動將履歷匯入)。</p>
            <h5><span class="badge badge-primary">優化項目</span></h5>
            <p>
              履歷欄位 |
              新增專長頁籤，國家、婚姻狀態、特殊身分、兵役狀態、血型、學校、學制、語言、方言、語言程度、證照、駕照、專長特色之資料來源，可由資料庫維護。<br />
              需求申請 |
              新增職務聯絡人資訊，招募方式、工作時間、薪資類型、學歷、科系、外語、方言、語言程度、駕照、證照之資料來源，可由資料庫維護。<br />
              任用結果 | 錄取通知信可一併發送Offer範本。<br />
            </p>
            <h5><span class="badge badge-warning">修正程式</span></h5>
            <p>
              觀看履歷 |
              修正匯出履歷PDF，部份欄位如果沒有資料會無法匯出的問題。<br />
            </p>
            <hr class="mt-4" style="border-top: 1px dashed #808080" />
            <strong> v1.007</strong>
            <h5><span class="badge badge-success">新增功能</span></h5>
            <p>
              面談紀錄 |
              完成評估功能增加備註欄位(非必填)，選擇評估結果時可一併輸入備註。
            </p>
            <h5><span class="badge badge-primary">優化項目</span></h5>
            <p>
              系統設定 | 後台自動登出時間改為可在資料庫中調整。<br />
              需求查詢 |
              列表上增加顯示當前簽核者，如已簽核完畢則顯示最後一位簽核者。<br />
              需求申請 |
              列表上增加顯示當前簽核者，如已簽核完畢則顯示最後一位簽核者。<br />
              任用結果 |
              列表上增加顯示當前簽核者，如已簽核完畢則顯示最後一位簽核者。<br />
              職缺管理 |
              履歷數量、面談結果列表上增加顯示是否已發送感謝函，如果已發送過，再次發送前跳出提示。<br />
              招聘進度 |
              邀約面談、面談結果列表上增加顯示是否已發送感謝函，如果已發送過，再次發送前跳出提示。
            </p>
            <h5><span class="badge badge-warning">修正程式</span></h5>
            <p>
              招聘進度 | 單位主管使用的各功能，移除部門篩選條件。<br />
              參數設定 | 調整參數名稱與排序。<br />
              各功能 | 列表功能分頁方式調整。
            </p>
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              關閉
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["page"],

  name: "Footer",
  data() {
    return {
      url: window.location.origin,
    };
  },
};
</script>

<style lang="scss" scoped>
.yahome-footer {
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  font-size: 0.9em;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 3;
  text-align: center;
  a {
    color: #fff;
  }
}
</style>
